import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { initAppsFlyerBanner } from "utils/apps-flyer";
import { useStatsigExperiment } from "hooks/experiments/use-statsig-experiments";
import { Container, Logo, Main, Content } from "./styles";

export function ConfirmationLayout() {
  const [urlUpdated, setUrlUpdated] = useState(false);
  const { getExperimentValue, trackExperimentView } = useStatsigExperiment({
    dontTrack: true,
  });
  const { bannerType } = getExperimentValue("exp_mobile_confirmation_banner");

  useEffect(() => {
    if (!bannerType) return;
    const url = new URL(window.location.href);
    url.searchParams.set("banner_type", bannerType);
    window.history.replaceState({}, "", url);
    setUrlUpdated(true);
  }, [bannerType]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!urlUpdated) return;
    initAppsFlyerBanner();
    trackExperimentView("exp_mobile_confirmation_banner");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlUpdated, bannerType]);

  return (
    <Container>
      <Main>
        <Logo />
        <Content>
          <Outlet />
        </Content>
      </Main>
    </Container>
  );
}
